/**
 * ChatBot Service
 * 
 * NOTE FOR API INTEGRATION:
 * When your backend API is ready:
 * 1. Replace the mock implementation in `sendMessageToBot` with your API call:
 *    Example:
 *    const response = await axios.post(`${API_BASE_URL}/chat`, { message: userMessage, conversationId });
 *    return response.data.reply;
 * 
 * 2. Update `getInitialSuggestions` if suggestions come dynamically from your API.
 */

// Initial quick suggestion prompts for users
export const INITIAL_SUGGESTIONS = [
  "How to submit a manuscript?",
  "What are Article Processing Charges (APC)?",
  "Peer review process overview",
  "Author & reviewer guidelines",
  "How do I contact editorial support?"
];

// Static knowledge base for mock replies
const MOCK_KNOWLEDGE_BASE = [
  {
    keywords: ["submit", "manuscript", "submission", "how to publish", "paper"],
    reply: "To submit your manuscript:\n1. Log in or create an author account.\n2. Click on 'Submit Manuscript' from the menu or dashboard.\n3. Upload your manuscript files (Word/PDF) and follow the step-by-step submission wizard."
  },
  {
    keywords: ["apc", "charge", "charges", "fee", "cost", "price", "pay", "payment"],
    reply: "Aakashganga is dedicated to open-access research. Article Processing Charges (APC) vary depending on the journal discipline and author category. Please check our 'Article Publishing Charge' page or contact support for fee waivers and institutional subsidies."
  },
  {
    keywords: ["peer review", "reviewer", "review", "status", "timeline"],
    reply: "We follow rigorous, transparent peer-review models. You can monitor the real-time review progress of your submission directly from your Author Dashboard under 'My Articles'."
  },
  {
    keywords: ["guideline", "guidelines", "format", "formatting", "template"],
    reply: "Detailed formatting templates and submission guidelines are available under the 'Author Guidelines' and 'Submission Guidelines' sections on our platform."
  },
  {
    keywords: ["contact", "support", "email", "phone", "help", "editor"],
    reply: "You can reach our editorial support team at:\n📧 contactus@vikramshilaedu.in\nOur team is available Monday to Friday to assist you."
  },
  {
    keywords: ["hello", "hi", "hey", "good morning", "good evening", "namaste"],
    reply: "Hello! I'm Tara, your research & publishing assistant at Aakashganga. How can I assist you today?"
  },
  {
    keywords: ["who are you", "what is your name", "your name", "tara"],
    reply: "I'm Tara! I'm here to help you navigate Aakashganga—from manuscript preparation and submission to peer review, APC inquiries, and editorial policies."
  },
  {
    keywords: ["thank", "thanks", "thank you"],
    reply: "You're very welcome! Let me know if you need help with anything else. Good luck with your research!"
  }
];

export const sendMessageToBot = async (userMessage, history = []) => {
  try {
    const response = await fetch('https://168.144.67.207.sslip.io/api/v1/query', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ 
        question: userMessage,
        history: history,
        top_k: 5
      })
    });
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    const data = await response.json();
    return data.answer || "Sorry, I couldn't find an answer to that question.";
  } catch (error) {
    console.error("ChatBot API Error:", error);
    return "Sorry, I am having trouble connecting to the server. Please try again shortly.";
  }
};

export const getWelcomeMessage = async () => {
  try {
    const response = await fetch('https://168.144.67.207.sslip.io/api/v1/welcome');
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    return data.greeting || null;
  } catch (error) {
    console.error("Welcome API Error:", error);
    return null;
  }
};

